import Spinner from 'src/javascripts/components/utilities/Spinner';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class MastersSearchTypeahead {

  constructor(el) { this.el = el; }

  render() {
    const accountUrl = $('body').attr('data-account-url');
    let params = {};
    let searchableType = $('#master_search_typeahead').attr('data-searchable-type');
    params['searchable_type'] = searchableType;
    let url = '/' + accountUrl + '/search_results?' + $.param(params);

    const searchBloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: url + '&query=%QUERY',
        wildcard: "%QUERY",
        cache: false
      }});

    searchBloodhound.initialize();

    const noResultsTemplate = () => '<div class="empty-message">Unable to find anything</div>';

    const resultDisplayTemplate = (name, description, link, searchable_type, bg_color) => 
      '<div class=\'overflow-hidden bg-gray100 border border-rounded px-3 d-flex flex-column justify-content-center position-relative mb-3\' style=\'height: 70px;\'>' +
      '<a href=\'' + link + '\' class=\'gray-link stretched-link\' data-turbo-stream=\'true\'>' +
      '<div class="w-100 mb-1">' +
      '<div class="d-inline-block" style=\'width: 85%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\'>' + name + '</div>' +
      '</div>' +
      '<div class="position-absolute Badge small ' + bg_color + '" style=\'top: 5px; right: 5px;\'>' + searchable_type + '</div>' +
      '<div class="w-100 text-gray600 font-weight-light" style=\'height: 22px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\'>' + description + '</div>' +
      '</a>' +
      '</div>';

    $('#master_search_typeahead').typeahead({
      hint: true,
      highlight: true,
      minLength: 0,
      classNames: {
        menu: 'd-none' // add class name to menu so default dropdown does not show
      }
    }, {
      name: 'search_results',
      display: 'name',
      limit: 202,
      source: searchBloodhound.ttAdapter(),
      menu: '#searchList'
    });

    $('#master_search_typeahead').bind('typeahead:asyncrequest', function(e, datum) {
      $('#masterSearchResults').empty();
    });

    $('#master_search_typeahead').bind('typeahead:render', function(e, datum) {
      $('#masterSearchResults').empty();
      var suggestions = Array.prototype.slice.call(arguments, 1);
      if (suggestions.length) {

        for (var c = 0; c < suggestions.length; c++) {

          // Set template to render
          let template;

          if ( (suggestions[c].name !== null) ) {

            template = resultDisplayTemplate(
              suggestions[c].name, 
              suggestions[c].description, 
              suggestions[c].link,
              suggestions[c].searchable_type_plural,
              suggestions[c].bg_color
            );

          } else {

            // Set template to render
            template = noResultsTemplate();
            
          }

          // Append to companies search list
          $('#masterSearchResults').append(template);

        }

      }

      // Remove spinner
      $('#masterSearchResults').find('.spinner-container').remove();

    });

    // Focus on show
    $('#masterSearchModal').on('shown.bs.modal', function() {
      $('#master_search_typeahead').focus();
    });

    
  }

}
